import actions from "src/modules/auth/authActions";
const authInitializer = (store) => store.dispatch(actions.doInit());
export default authInitializer;
